/**
 * Which sub-account of a ProvisionAgent a transaction type books against. RESERVE_ACCOUNT is the
 * German "Rücklagenkonto" (formerly "Stornokonto").
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionAccountKind}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end — never inserted between
 * existing ones, which would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionAccountKind {

    PROVISION_ACCOUNT,
    RESERVE_ACCOUNT
}
